/**
 * BrightnessIcon icon set component.
 * Usage: <BrightnessIcon name="icon-name" size={20} color="#4F8EF7" />
 */
import { createIconSetFromIcoMoon } from '@expo/vector-icons'
import React from 'react'
import { StyleSheet } from 'react-native'

import icoMoonConfig from './icon-config.json'

const Icon = createIconSetFromIcoMoon(icoMoonConfig, 'brightness')
const styles = StyleSheet.create({
  container: {
    textAlign: 'center',
    backgroundColor: 'transparent',
  },
})

export default class BrightnessIcon extends React.Component {
  render() {
    const { brightness, size, color, style } = this.props
    if (brightness === undefined || brightness < 0) return null

    switch (brightness) {
      case 3:
        name = 'ocircle'
        break
      case 2:
        name = 'circle'
        break
      case 1:
        name = 'triangle'
        break
      case 0:
        name = 'cross'
        break
    }
    return (
      <Icon
        name={name}
        size={size || 14}
        color={color}
        style={[styles.container, style]}
      />
    )
  }
}
// export default iconSet

// export const Button = iconSet.Button
// export const TabBarItem = iconSet.TabBarItem
// export const TabBarItemIOS = iconSet.TabBarItemIOS
// export const ToolbarAndroid = iconSet.ToolbarAndroid
// export const getImageSource = iconSet.getImageSource
